import styled, { css } from 'styled-components';
import CreatableSelect from 'react-select/creatable';

import { pickColor } from 'themes/helpers/pickColor';
import { FontScaleName, getFontScale } from 'themes/mixins/getFontScale';
import { mediaMinWidth } from 'themes/mixins/mediaQueries';

import { Headline } from 'components/Headline';

export type StyledSelectProps = {
  scale?: FontScaleName;
  isAdditionalTheme?: boolean;
};

const Container = styled.div<StyledSelectProps>`
  position: relative;

  display: flex;
  flex-direction: ${({ isAdditionalTheme }) => (isAdditionalTheme ? 'row' : 'column')};

  ${getFontScale}

  ${mediaMinWidth.md(css`
    width: 100%;
  `)}
`;

const Label = styled(Headline)<StyledSelectProps>`
  height: 1.9rem;
  padding: 0;

  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: 0.1rem;

  color: ${pickColor('black')};

  ${getFontScale}
`;

const Select = styled(CreatableSelect)`
  width: 100%;

  text-transform: uppercase;
  color: ${pickColor('gray')};
`;

const ErrorMessage = styled(Headline)`
  margin-left: 1.2rem;
`;

const Header = styled.div<StyledSelectProps>`
  display: flex;
  align-items: center;

  height: 1.9rem;
  ${({ isAdditionalTheme }) =>
    isAdditionalTheme &&
    css`
      min-width: 14rem;
    `}
`;

export { Container, Header, Label, Select, ErrorMessage };
